import {reqProduction,reqManufacture} from '../api'
export default {
    namespaced:true,
    actions: {
        // 得到 生产信息列表
        async getProductionList({commit,state},{queryInfo}) {
            const result = await reqProduction(queryInfo.currentPage,queryInfo.rowCount,queryInfo.name,queryInfo.status);
            if (result.code === 1) {
                const productionList = result.data.data;
                const productionTotal = result.data.totalCount;
                console.log(productionList);
                commit("RECEIVE_PRODUCTION_LIST",{productionList,productionTotal});
            }
        },
        // 得到加工信息数据列表
        async getManufactureList({commit,state},{queryInfo}) {
            const result = await reqManufacture(queryInfo.currentPage,queryInfo.rowCount,queryInfo.name,queryInfo.status);
            if (result.code === 1) {
                const manufactureList = result.data.data;
                const manufactureTotal = result.data.totalCount;
                console.log(manufactureList);
                commit("RECEIVE_MANUFACTURE_LIST",{manufactureList,manufactureTotal});
            }
        },
        // 得到追溯码信息数据列表
        /*async getCodeList({commit,state},{queryInfo}) {
            const result = await reqCode(queryInfo.currentPage,queryInfo.rowCount,queryInfo.name);
            if (result.code === 1) {
                const codeList = result.data.data;
                const codeTotal = result.data.totalCount;
                console.log(codeList);
                commit("RECEIVE_CODE_LIST",{codeList,codeTotal});
            }
        },*/
    },
    mutations: {
        // 生产信息
        RECEIVE_PRODUCTION_LIST: (state,{productionList,productionTotal}) => {
            state.productionList = productionList;
            state.productionTotal = productionTotal;
        },
        // 加工信息
        RECEIVE_MANUFACTURE_LIST: (state,{manufactureList,manufactureTotal}) => {
            state.manufactureList = manufactureList;
            state.manufactureTotal = manufactureTotal;
        },
        // 追溯码信息
        /*RECEIVE_CODE_LIST: (state,{codeList,codeTotal}) => {
            state.codeList = codeList;
            state.codeTotal = codeTotal;
        },*/
    },
    state: {
        productionList: [], // 生产信息数据列表
        productionTotal: 0, // 生产信息数据总条数
        manufactureList: [], // 加工信息数据列表
        manufactureTotal: 0, // 加工信息数据总条数
        /*codeList: [], // 追溯码信息数据列表
        codeTotal: 0, // 追溯码信息数据总条数*/

    },
    getters: {

    }
}



// WEBPACK FOOTER //
// ./src/store/allTrace.js